<ada-icon
	ada-color="primary"
	icon="faCodeFork"
/>
<div class="ada-chat-fork-info">
	<span ada-color="primary"> Building from: </span>
	<span
		ada-color="foreground"
		[title]="forkName()"
	>
		{{ forkName() }}
	</span>
</div>
